import useSWR from "swr";
import investServices from "@/services/apiServices/investServices/index.js";

const useTransactions = () => {
  return useSWR(`getTransactionFiles`, investServices.getTransactionFiles);
};

export default useTransactions;
